<template>
  <div>

    <router-link
      :to="{name: 'setting-accessibility-list'}"
      class="text-decoration-none text-white"
    >
      <b-button
        class="mb-1"
        variant="primary"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          class="mr-75"
        />
        Kembali
      </b-button>
    </router-link>
    <b-card>
      <!-- required required Wajib diisi -->
      <!-- min:x min:3 Minimal x karakter -->
      <!-- max:x max:10 Maksimal x karakter -->
      <!-- email email Format email valid -->
      <!-- numeric numeric Hanya angka -->
      <!-- between:x,y between:1,10 Antara nilai x dan y -->
      <!-- confirmed confirmed:password Cocok dengan field lain -->
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <!-- Nama Supplier -->
            <b-col
              xl="6"
              md="12"
            >
              <b-form-group
                label="Nama Jabatan"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Masukkan Nama Jabatan"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              xl="6"
              md="12"
            >
              <b-form-group
                label="Akses Menu"
                label-for="ability"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Akses Menu"
                  rules="required"
                >
                  <v-select
                    v-model="abilities"
                    :options="ablOpt"
                    hint="Pilih Menu Yang Dapat Diakses"
                    label="title"
                    multiple
                    persistent-hint
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- Tombol Aksi -->
            <b-col
              md="12"
            >
              <b-button
                type="submit"
                variant="success"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Simpan
              </b-button>
              <b-button
                type="reset"
                variant="outline-secondary"
              >
                Reset
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer></b-card>

  </div>
</template>

<script>
import {
  BFormInput, BFormGroup, BRow, BCol, BButton, BCard, BForm,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
// eslint-disable-next-line import/no-cycle
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BRow,
    BForm,
    BCol,
    BButton,
    BCard,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      name: null,
      abilities: [],
      ablOpt: [],
      required,
    }
  },
  computed: {},
  created() {
    this.$http.get('/ability')
      .then(res => {
        this.ablOpt = res.data.data.map(abl => ({
          value: abl.id,
          title: abl.name.charAt(0).toUpperCase() + abl.name.slice(1),
        }))
      })
  },
  mounted() {
  },
  methods: {
    submit() {
      const payload = {
        name: this.name,
        abilities: this.abilities,
      }

      this.$http.post('/role/add', payload)
        .then(() => {
          this.$bvToast.toast('Jabatan berhasil ditambahkan!', {
            title: 'Sukses',
            variant: 'success',
            solid: true,
          })
          // Reset redirect
          this.$router.push({ name: 'setting-accessibility-list' })
        })
        .catch(err => {
          const message = err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Gagal menyimpan data Jabatan.'

          console.error(err)

          this.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submit()
        } else {
          this.$bvToast.toast('Lengkapi Data Sebelum Submit!', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        }
      })
    },
  },
}
</script>
